import React from 'react'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import PropTypes from 'prop-types'

const APP_ID = '106401512762894'

class FacebookSignIn extends React.Component {
  onFailure = error => {
    const { onCancel, onError } = this.props
    if (error && error.status) {
      if (typeof onCancel === 'function') {
        onCancel(error.status)
      }
      return
    }
    if (typeof onError === 'function') {
      onError({ code: 'facebook_unexpected_error', message: JSON.stringify(error) })
    }
  }

  render() {
    const { render, onSuccess, facebookAppId } = this.props
    const appId = facebookAppId || APP_ID

    return (
      <FacebookLogin
        appId={appId}
        autoLoad={false}
        disableMobileRedirect
        callback={onSuccess}
        onFailure={this.onFailure}
        render={({ onClick }) => render({ onClick })}
      />
    )
  }
}

FacebookSignIn.propTypes = {
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  render: PropTypes.func.isRequired,
}

export default FacebookSignIn
